// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrExpenseDto
 */
export interface IOcrExpenseDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IOcrExpenseDto interface.
 */
export function instanceOfIOcrExpenseDto(value: object): value is IOcrExpenseDto {
    return true;
}

export function IOcrExpenseDtoFromJSON(json: any): IOcrExpenseDto {
    return IOcrExpenseDtoFromJSONTyped(json, false);
}

export function IOcrExpenseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrExpenseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IOcrExpenseDtoToJSON(json: any): IOcrExpenseDto {
    return IOcrExpenseDtoToJSONTyped(json, false);
}

export function IOcrExpenseDtoToJSONTyped(value?: IOcrExpenseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

